<svg
  [attr.viewBox]="'0 0 ' + SIZE + ' ' + SIZE"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="inputSize"
  [attr.height]="inputSize"
  [attr.colors]="colors"
  [attr.name]="name"
  [attr.size]="inputSize"
>
  <path d="M90 45a45.001 45.001 0 00-76.82-31.82A45 45 0 000 45h90z" [attr.fill]="cellColors[0]" />
  <path d="M90 45a45.001 45.001 0 01-76.82 31.82A45 45 0 010 45h90z" [attr.fill]="cellColors[1]" />
  <path d="M83 45a38 38 0 00-76 0h76z" [attr.fill]="cellColors[2]" />
  <path d="M83 45a38 38 0 01-76 0h76z" [attr.fill]="cellColors[3]" />
  <path d="M77 45a32 32 0 10-64 0h64z" [attr.fill]="cellColors[4]" />
  <path d="M77 45a32 32 0 11-64 0h64z" [attr.fill]="cellColors[5]" />
  <path d="M71 45a26 26 0 00-52 0h52z" [attr.fill]="cellColors[6]" />
  <path d="M71 45a26 26 0 01-52 0h52z" [attr.fill]="cellColors[7]" />
  <circle cx="45" cy="45" r="23" [attr.fill]="cellColors[8]" />
</svg>
